/**
 * NOTE: Live activities widget is iOS only.
 */
export const useLiveActivityTelemetry = () => {};
